/* eslint-disable prefer-const */
import React from 'react';
import parse from 'html-react-parser';
import { Accordion } from 'react-bootstrap';
import { IContentGroup } from '../../helpers/interfaces';

interface BlogAccordionProps {
  data: IContentGroup[];
  id: string;
}
export default class BlogAccordion extends React.Component<BlogAccordionProps> {
  render() {
    const { data, id } = this.props;
    return (
      <Accordion
        alwaysOpen
        flush
        className="accordion-angle-icon mb-4">
        {data.map((accordionItem: IContentGroup, index: number) => {
          const itemKey = `accordion-item-${index}`;
          // const eventKey = index.toString();
          const buttonId = `${id}${index}accordh`;
          const bodyId = `${id}${index}accordb`;
          return (
            <Accordion.Item
              key={itemKey}
              eventKey={itemKey}>
              <h3 className="accordion-header h5">
                <Accordion.Button
                  className="py-4"
                  id={buttonId}
                  aria-controls={bodyId}>
                  {typeof accordionItem.title === 'string'
                    ? parse(accordionItem.title)
                    : accordionItem.title}
                </Accordion.Button>
              </h3>
              <Accordion.Body
                id={bodyId}
                aria-labelledby={buttonId}
                role="region">
                {accordionItem.content}
              </Accordion.Body>
            </Accordion.Item>
          );
        })}
      </Accordion>
    );
  }
}
